var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.temporaryTags.length)?_c('ul',{staticClass:"w-full flex flex-col md:flex-row flex-wrap"},_vm._l((_vm.temporaryTags),function(tag,index){return _c('li',{key:index},[_c('BaseTag',_vm._b({},'BaseTag',tag,false))],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }